@if (pagelet()?.stringParam('quickOrderEnabled') === 'true') {
<li
  #quickOrderFlyout
  id="quickorder-nav"
  (mouseenter)="manageLeft()"
  *ishFeature="'customQuickorder'"
  class="dropdown quickorder-nav"
>
  <a [routerLink]="pagelet()?.stringParam('RouterLink')">
    {{ pagelet()?.stringParam('RouterTitle') }}
  </a>
  <div id="quickorderFlyoutView" class="quickorder-flyout">
    <custom-lazy-quickorder-flyout />
  </div>
</li>
} @else {
<li id="quickorder-nav" *ishFeature="'customQuickorder'" class="dropdown quickorder-nav">
  <a [routerLink]="pagelet()?.stringParam('RouterLink')">
    {{ pagelet()?.stringParam('RouterTitle') }}
  </a>
</li>
}
